module.exports = __webpack_public_path__ + "static/Graphik-Medium-Web-858e09c897d7d00c4d9fbf9d625c46d6.woff2";